
import Vue from 'vue'
import CambioNombreComercial from '@/components/Solicitudes/Multiples/CambioNombreComercial.vue';
import CambioDomicilio from '@/components/Solicitudes/Multiples/CambioDomicilio.vue';
import CambioActividadEconomica from '@/components/Solicitudes/Multiples/CambioActividadEconomica.vue';
import EstablecimientoService from '@/services/EstablecimientoService';

export default Vue.extend({
    name: 'MultiplesRenovacion',
    components: {
        CambioNombreComercial,
        CambioDomicilio,
        CambioActividadEconomica
    },
    props: {
        establecimiento: {
            type: Object,
            default: null as any,
        },
        dialogPrincipal: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    data: () => ({
        solicitudes: [] as any,
        dialogCambioNombreComercial: false,
        dialogCambioDomicilio: false,
        dialogCambioActividadEconomica: false,
        hasCambioNombreComercial: false,
        hasCambioDomicilio: false,
        hasCambioActividadEconomica: false,
        canUpdateCambioNombreComercial: false,
        canUpdateCambioDomicilio: false,
        canUpdateCambioActividadEconomica: false,
        deleteCambioNombreComercial: false,
        deleteCambioDomicilio: false,
        deleteCambioActividadEconomica: false,
        mount: false,
    }),
    methods: {
        closeDialogPrincipal() {
            this.hasCambioNombreComercial = false
            this.hasCambioDomicilio = false
            this.hasCambioActividadEconomica = false
            this.canUpdateCambioNombreComercial = false
            this.canUpdateCambioDomicilio = false
            this.canUpdateCambioActividadEconomica = false
            this.$emit('close');
        },
        openCambioNombreComercial(borrar: boolean = false) {
            this.dialogCambioNombreComercial = true;
            this.deleteCambioNombreComercial = borrar;
        },
        closeCambioNombreComercial() {
            this.dialogCambioNombreComercial = false;
            this.deleteCambioNombreComercial = false
        },
        openCambioDomicilio(borrar: boolean = false) {
            this.dialogCambioDomicilio = true;
            this.deleteCambioDomicilio = borrar;
        },
        closeCambioDomicilio() {
            this.dialogCambioDomicilio = false;
            this.deleteCambioDomicilio = false
        },
        openCambioActividadEconomica(borrar: boolean = false) {
            this.dialogCambioActividadEconomica = true;
            this.deleteCambioActividadEconomica = borrar;
        },
        closeCambioActividadEconomica() {
            this.dialogCambioActividadEconomica = false;
            this.deleteCambioActividadEconomica = false
        },
        async getData() {
            this.hasCambioNombreComercial = false;
            this.hasCambioDomicilio = false;
            this.hasCambioActividadEconomica = false;
            this.canUpdateCambioNombreComercial = false;
            this.canUpdateCambioDomicilio = false;
            this.canUpdateCambioActividadEconomica = false;
            this.deleteCambioNombreComercial = false;
            this.deleteCambioDomicilio = false;
            this.deleteCambioActividadEconomica = false;
            const { data } = await EstablecimientoService.solicitudesCambioExtra(this.establecimiento.id)
            this.solicitudes = data
            this.$emit('solicitudesCambioExtra', this.solicitudes);
            if (this.solicitudes.includes(1)) {
                this.hasCambioNombreComercial = true;
                this.canUpdateCambioNombreComercial = true;
            }
            if (this.solicitudes.includes(2)) {
                this.hasCambioDomicilio = true;
                this.canUpdateCambioDomicilio = true;
            }
            if (this.solicitudes.includes(3)) {
                this.hasCambioActividadEconomica = true;
                this.canUpdateCambioActividadEconomica = true;
            }
        },
    },
    watch: {
        establecimiento() {
            if (this.establecimiento.id) {
                this.getData();
            }
        },
        dialogPrincipal() {
            if (this.dialogPrincipal) {
                this.getData();
            }
        }
    },
})
